import { FormItemWithIconClick } from 'src/components/form-item-with-icon-click';

export default FormItemWithIconClick;
